

import React from 'react';
import { CompanyVehicleInsert } from '@/types';
import { AddEntityButton } from '@/shared/components/AddEntityButton';
import { FormField } from '@/shared/components/GenericFormDialog';

/**
 * 車両情報の追加ボタンのprops
 */
interface AddCompanyVehicleButtonProps {
    onAdd: (data: CompanyVehicleInsert) => Promise<boolean>;
    className?: string;
    disabled?: boolean;
}

/**
 * 車両情報の追加ボタン (Generic版)
 * 汎用AddEntityButtonを使用した実装
 */
const AddCompanyVehicleButton: React.FC<AddCompanyVehicleButtonProps> = ({
    onAdd,
    className,
    disabled = false
}) => {

    // フォームフィールドの定義
    const fields: FormField[] = [
        {
            key: 'name',
            label: '車両名',
            type: 'text',
            required: true,
            placeholder: '車両名を入力してください',
        },
        {
            key: 'daily_cost',
            label: '日額料金 (円)',
            type: 'number',
            required: true,
            placeholder: '0',
        },
        {
            key: 'is_active',
            label: '有効',
            type: 'boolean',
            required: false,
        },
    ];

    /**
     * フォーム送信処理
     * @param data フォームデータ
     */
    const handleSubmit = async (data: Partial<Record<string, unknown>>) => {
        await onAdd(data as unknown as CompanyVehicleInsert);
    };

    return (
        <AddEntityButton
            entityName="車両"
            fields={fields}
            onSubmit={handleSubmit}
            isLoading={disabled}
            buttonText="新規追加"
            className={className}
        />
    );
};

export default AddCompanyVehicleButton; 